import { ControlKeyMismatchError, InvalidSsnFormatError } from './errors';
var validateFormat = function (validator, ssn) {
    var isMatching = validator.ssnRegex.test(ssn);
    if (!isMatching) {
        throw new InvalidSsnFormatError();
    }
};
var validateControlKey = function (validator, ssn) {
    try {
        var actualControlKey = validator.extractSsnControlKey(ssn);
        var expectedControlKey = validator.computeSsnControlKey(ssn);
        if (actualControlKey !== expectedControlKey) {
            throw new ControlKeyMismatchError(expectedControlKey, actualControlKey);
        }
    }
    catch (error) {
        if (error instanceof ControlKeyMismatchError) {
            throw error;
        }
        throw new InvalidSsnFormatError();
    }
};
export default function validateSsn(validator, ssn) {
    validateFormat(validator, ssn);
    validateControlKey(validator, ssn);
}
